//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import GridMenu from '../component/grid/gridMenu';
import HomeChart from '../component/chart/homeChart';
import CenterGrid from '../component/grid/centerGrid';
import AllApp from '../apps/pages/allApp';
import empExperience from '../component/empExperience';
import autoScrollMixin from '../component/mixins/autoScrollMixin';

export default {
    name: 'home',
    mixins: [autoScrollMixin],
    created() {
        this.loadHome();
    },
    data() {
        return {
            news: [], //轮播
            mymsg: {}, //消息提醒
            liveData: [], //即时数据
            firstReportData: [], //第1个报表数据
            reportList: [], //报表列表
            myresumeData: [], //履历数据
            myresumeList: [], //履历列表
            favApps: [], //我的应用
            isShowAllApp: false,
            isShowMineApp: false,
            requestUrl: 'home/getHome'
        }
    },
    methods: {
        loadHome() {
            this.$x.post('home/getHome', {})
                .then(res => {
                    this.news = res.news;
                    this.firstReportData = res.firstReportData;
                    let reportList = [];
                    let myresumeList = [];
                    if (res.mymsg) {
                        this.mymsg = res.mymsg[0];
                    }
                    if (res.reportList) {
                        reportList = res.reportList.map((row, i) => {
                            row.type = 'home';
                            return row;
                        });
                    }
                    this.reportList = reportList;

                    //履历列表
                    if (res.myresumeList) {
                        myresumeList = res.myresumeList.map((row, i) => {
                            row.active = false;
                            row.title = row.xseqno + '.' + row.title;
                            //履历详细数据
                            if (res.myresumeData.length) {
                                row.data = res.myresumeData.filter((row2, j) => {
                                    if (row2.evtid === row.id) {
                                        var bgcolor = 'mid-primary';
                                        //首尾背景颜色
                                        if (j === 0) {
                                            bgcolor = 'details-sort-circle_start';
                                        }
                                        row2.bgcolor = bgcolor;
                                        return row2;
                                    }
                                });
                                if (row.data.length) {
                                    row.data[row.data.length - 1].bgcolor = 'details-sort-circle_end';
                                }
                            } else {
                                row.data = [];
                            }
                            return row;
                        });
                    }
                    //即时数据，分页，每页6个
                    const liveData = [];
                    if (res.liveData) {
                        for (let i = 0; i < Math.ceil(res.liveData.length / 6); i++) {
                            liveData[i] = res.liveData.slice(i * 6, (i + 1) * 6);
                        }
                    }
                    this.liveData = liveData;
                    this.myresumeList = myresumeList;

                    //我的应用
                    if (res.isShowAllApp) {
                        this.isShowAllApp = true;
                    } else {
                        this.isShowMineApp = true;
                        const favApps = res.favApps.map((row, i) => {
                            row.xcolorid = i + 1;
                            row.iconmobile = row.bsimg;
                            return row;
                        });
                        this.favApps = favApps;
                    }

                    this.$nextTick(() => {
                        if (this.isShowMineApp) {
                            this.autoScroll()
                            this.resetQuery()
                        }
                    })
                })
        },
        goMsgList() {
            const route = ['/msg/news', '/msg/wftask', '/msg/wfHistory'];
            this.$router.push(route[this.mymsg.xdefaulttab - 1]);
        },
        goNews(newsItem) {
            var url = 'PortalMobile/News.aspx?id=' + newsItem.id;
            this.$x.jumpApp(url);
        },
        goMoreApp(e) {
            this.$store.dispatch('setScrollTop', 0);
            this.$router.push('/myapp')
        },
        openApp(cell) {
            this.$x.jumpMenu(cell)
        },
    },
    components: { AllApp, CenterGrid, HomeChart, GridMenu, empExperience },
}
